import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import GroupedButton from "src/components/buttons/grouped-button/GroupedButton";
import { DeleteIcon } from "src/icons/DeleteIcon";
import { EditIcon } from "src/icons/EditIcon";
import { ViewIcon } from "src/icons/ViewIcon";
import { hasDeleteAccess, hasEditAccess } from "src/redux/selectors/app";

const ActionsCell = ({
  value,
  onDelete,
}: {
  value: number;
  onDelete: () => void;
}) => {
  const navigate = useNavigate();

  const hasEditPermission = useSelector(hasEditAccess);
  const hasDeletePermission = useSelector(hasDeleteAccess);

  const options = [
    {
      icon: EditIcon,
      onClick: () => navigate(`/store/vendor/inventory/all/create/${value}`),
      disabled: !hasEditPermission,
      tooltip: hasEditPermission
        ? "Edit"
        : "You don't have permission to edit.",
    },
    {
      icon: ViewIcon,
      tooltip: "View",
      onClick: () => navigate(`/store/vendor/inventory/all/view/${value}`),
    },
    {
      icon: DeleteIcon,
      onClick: onDelete,
      disabled: !hasDeletePermission,
      tooltip: hasDeletePermission
        ? "Delete"
        : "You don't have permission to delete.",
    },
  ];

  return (
    <div className="flex items-center justify-center">
      <GroupedButton options={options} />
    </div>
  );
};

export default ActionsCell;
